import { h, Component } from 'preact'
import _ from './styles.sass'
import nextIcon from './nexticon.svg'

// import TabBar from '@shared/components/TabBar'
import DayGraph from '@components/DayGraph'
import YearGraph from '@components/YearGraph'
import StationSelector from '@components/StationSelector'
import MarkerOnMapShape from '@components/MarkerOnMapShape'
import colorScale from '@root/lib/colorScale'
// import moment from 'moment'
// import 'moment-timezone'
// import colors from '@shared/styles/colors.sass'
import { latestValue, yearMeanValue } from '@root/lib/valuesFromStation'
import InfoBox from '@shared/components/InfoBox'

export default class Station extends Component {
  selectStation = ({ byIndex: index }) => () => {
    this.context.actions.selectMarker({ byIndex: index })
  }

  render () {
    const { station, allStations, selectedStationIndex, selectedDataset } = this.props

    const dayIsSelected = selectedDataset === 'day'
    const stationSelectorProps = {
      allStations, selectedStationIndex, selectedDataset
    }

    const previousStation = allStations[selectedStationIndex - 1]
    const nextStation = allStations[selectedStationIndex + 1]

    const value = dayIsSelected ? latestValue(station) : yearMeanValue(station)
    const color = colorScale(value)
    const isInBerlin = station.properties.federalstate === 'Berlin'

    const markerOnMapShapeProps = {
      feature: station,
      color: color,
      isInBerlin: isInBerlin
    }

    // const dateString = moment().tz('Europe/Berlin').locale('de').format('D.MMMM YYYY')
    // const dayInfoText = new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'short', day: 'numeric' })
    // const oldestYearDate = station.properties.last12MonthsMedians[station.properties.last12MonthsMedians.length - 1].t
    // const newestYearDate = station.properties.last12MonthsMedians[0].t
    // const oldestYearString = new Date(oldestYearDate).toLocaleDateString('de-DE', { year: 'numeric', month: 'short' })
    // const newestYearString = new Date(newestYearDate).toLocaleDateString('de-DE', { year: 'numeric', month: 'short' })
    // const yearInfoText = `${oldestYearString} – ${newestYearString}`

    // const dayYearSelectorProps = {
    //   id: 'coloredDatasetSelector',
    //   title: 'Ansicht Auswählen',
    //   selectedValue: selectedDataset,
    //   options: [
    //     { value: 'day', display: 'Heute', color: dayIsSelected ? color : colors.lightGrey },
    //     { value: 'year', display: 'letzte 12 Monate', color: dayIsSelected ? colors.lightGrey : color }
    //   ],
    //   onChange: this.context.actions.selectDataset
    // }

    return <div class={_.wrapper}>
      <div class={_.infoBox}>
        <div class={_.infoWithMapShape}>
          <MarkerOnMapShape {...markerOnMapShapeProps} />
          <div class={_.titleWrapper}>
            <h2 class={_.title}>{station.properties.name}</h2>
            <p class={_.info}>
              Quelle: Daten der Messnetze des Bundes und der Länder
            </p>
          </div>
        </div>

        {/* <TabBar class={_.dayYearSelector} {...dayYearSelectorProps} /> */}

        <label class={_.rankingLabel} for='station-ranking'>Alle Messpunkte:</label>
        <StationSelector id='station-ranking' {...stationSelectorProps} />

        { !!previousStation &&
          <button class={`${_.prevNextButton} ${_.prev}`} onClick={this.selectStation({byIndex: selectedStationIndex - 1})}>
            <img src={nextIcon} />
          </button>
        }
        { !!nextStation &&
          <button class={`${_.prevNextButton} ${_.next}`} onClick={this.selectStation({byIndex: selectedStationIndex + 1})}>
            <img src={nextIcon} />
          </button>
        }
      </div>
      { selectedDataset === 'day'
        ? <DayGraph station={station} />
        : <YearGraph station={station} />
      }
      <InfoBox />
    </div>
  }
}
